import { FilterKey, FilterResourceType } from '@features/components/CaseOverview/components/AssignedResources/types';
import { CustomerRole, CustomerRoleT } from '@/api/apis/customer';
import { AffiliationType as AffiliationTypeEnum, EmployeeRole } from '@/api/apis/resources';
import { Uuid } from '@/api/types';
import { SelectItemType } from '@/types';

export enum SurgeonType {
  Employee = 'employee',
  Contractor = 'contractor',
}

export enum ActiveResourceType {
  TmdxUser = 'tmdxUser',
  TxCenterContact = 'txCenterContact',
  ClinicalSpecialist = 'clinicalSpecialist',
  RetrievalSurgeon = 'retrievalSurgeon',
  ClinicalCoordinator = 'clinicalCoordinator',
  ClinicalLead = 'clinicalLead',
  OrganManagementSpecialist = 'organManagementSpecialist',
  OpoContact = 'opoContact',
  Device = 'device',
  None = 'none',
}

export const SURGEON_TYPE_LABELS: Record<SurgeonType, string> = {
  [SurgeonType.Employee]: 'Employee',
  [SurgeonType.Contractor]: 'Contractor',
};

export type ResourceFilters = {
  [FilterKey.ResourceType]: FilterResourceType[];
  [FilterKey.TxCenterContact]: CustomerRoleT[];
  [FilterKey.TmdxUser]: EmployeeRole[];
  [FilterKey.SurgeonType]: SurgeonType[];
  [FilterKey.AffiliationType]: AffiliationTypeEnum[];
};

export const resourcesAssignFilters: ResourceFilters = {
  resourceType: [FilterResourceType.TmdxContacts],
  txCenterContact: [],
  tmdxUser: [],
  surgeonType: [SurgeonType.Employee],
  affiliationType: [],
};

export const resourceTypes = [
  {
    value: FilterResourceType.TXContacts,
    name: 'TX Center Contacts',
  },
  {
    value: FilterResourceType.OpoContacts,
    name: 'OPO Contacts',
  },
  {
    value: FilterResourceType.TmdxContacts,
    name: 'TMDX Contacts',
  },
  {
    value: FilterResourceType.Devices,
    name: 'Devices',
  },
];

export const txCenterContacts = [
  {
    value: CustomerRole.TxCenterCoordinator,
    name: 'TX Center Coordinator',
  },
  {
    value: CustomerRole.TxCenterAdministrator,
    name: 'TX Center Administrator',
  },
  {
    value: CustomerRole.ReceivingSurgeon,
    name: 'Receiving Surgeon',
  },
  {
    value: CustomerRole.TxCenterTransplantSupport,
    name: 'Transplant Support',
  },
];

export const tmdxUsers = [
  {
    value: EmployeeRole.ClinicalLead,
    name: 'Clinical Lead',
  },
  {
    value: EmployeeRole.SrLogisticsManager,
    name: 'Sr. Logistics Manager',
  },
  {
    value: EmployeeRole.LogisticsManager,
    name: 'Logistics Manager',
  },
  {
    value: EmployeeRole.OrganManagementSpecialist,
    name: 'OMS',
  },
  {
    value: EmployeeRole.ClinicalCoordinator,
    name: 'Clinical Coordinator',
  },
  {
    value: EmployeeRole.ClinicalSpecialist,
    name: 'Clinical Specialist',
  },
  {
    value: EmployeeRole.RetrievalSurgeon,
    name: 'Retrieval Surgeon',
  },
  {
    value: EmployeeRole.AviationSpecialist,
    name: 'Aviation Specialist',
  },
  {
    value: EmployeeRole.GroundSpecialist,
    name: 'Ground Specialist',
  },
];

export const rolesCantBeDetached = [
  EmployeeRole.ClinicalSpecialist,
  EmployeeRole.RetrievalSurgeon,
  EmployeeRole.QuoteApprovers,
  EmployeeRole.OrganLeadership,
];

export const organSpecificRoles = [
  EmployeeRole.ClinicalSpecialist,
  EmployeeRole.RetrievalSurgeon,
  EmployeeRole.OrganLeadership,
  EmployeeRole.ClinicalLead,
];

export const resourceTypeIs = (type: FilterResourceType, filters: ResourceFilters) => filters.resourceType[0] === type;

export const getResourceTypes = (txCenterId?: Uuid) => {
  let result = resourceTypes;
  if (!txCenterId) result = result.filter((rt) => rt.value !== FilterResourceType.TXContacts);

  return result;
};

export const surgeonTypeItems: SelectItemType[] = [
  { value: SurgeonType.Employee, name: SURGEON_TYPE_LABELS[SurgeonType.Employee] },
  { value: SurgeonType.Contractor, name: SURGEON_TYPE_LABELS[SurgeonType.Contractor] },
];

export const logisticsResourceTypes = [
  ActiveResourceType.Device,
  ActiveResourceType.RetrievalSurgeon,
  ActiveResourceType.ClinicalSpecialist,
];
